import { http } from '@frontend/fetch';
import { Pet, PetExtended } from './types';

export const getPersonPets = (personId: string) => http.getData<Pet[]>(`/desktop/v1/persons/${personId}/pets`);

export const getPet = (id: string) => http.getData<PetExtended>(`/desktop/v1/pets/${id}`);
